export const ACCOUNT_PAGE_LOAD_REQUESTED = 'ACCOUNT_PAGE_LOAD_REQUESTED';
export const ACCOUNT_PAGE_LOAD_SUCCEEDED = 'ACCOUNT_PAGE_LOAD_SUCCEEDED';
export const ACCOUNT_PAGE_LOAD_FAILED = 'ACCOUNT_PAGE_LOAD_FAILED';

export const loadAccountPageRequest = () => ({ type: ACCOUNT_PAGE_LOAD_REQUESTED });
export const loadAccountPageSuccess = () => ({ type: ACCOUNT_PAGE_LOAD_SUCCEEDED });
export const loadAccountPageFailure = () => ({ type: ACCOUNT_PAGE_LOAD_FAILED });

